"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDID = exports.simpleResolver = exports.lexiResolver = void 0;
const axios_1 = __importDefault(require("axios"));
const bs58_1 = require("bs58");
const key_1 = require("./key");
const augmentDIDLexi = (signer, encryptionKeyBox, publicSigningString) => async (didDocument) => {
    const keyPair = await (0, key_1.generateX25519KeyPairFromSignature)(signer, publicSigningString, encryptionKeyBox);
    const lexiKey = {
        id: `${didDocument.id}#lexi-key`,
        type: "X25519KeyAgreementKey2019",
        controller: didDocument.id,
        publicKeyBase58: (0, bs58_1.encode)(keyPair.publicKey),
    };
    // add the new key to the document
    return {
        ...didDocument,
        verificationMethod: [...(didDocument.verificationMethod ?? []), lexiKey],
        keyAgreement: [...(didDocument.keyAgreement ?? []), lexiKey.id],
    };
};
const augmentedResolver = (resolve, augmentDocument) => async (didUrl) => {
    const resolutionResult = await resolve(didUrl);
    if (!resolutionResult.didDocument)
        return resolutionResult;
    const augmentedDocument = await augmentDocument(resolutionResult.didDocument);
    return {
        ...resolutionResult,
        didDocument: augmentedDocument,
    };
};
const lexiResolver = (resolve, signer, encryptionKey, publicSigningString) => {
    return augmentedResolver(resolve, augmentDIDLexi(signer, encryptionKey, publicSigningString));
};
exports.lexiResolver = lexiResolver;
const simpleResolver = async (did) => {
    return axios_1.default
        .get("https://did.civic.com/1.0/identifiers/" + did, {
        headers: {
            // the uniresolver is sensitive to the accept header.
            // if application/json, it returns a did document, if missing or */*,
            // a did resolution response containing a did document
            Accept: "*/*",
        },
    })
        .then((res) => res.data);
};
exports.simpleResolver = simpleResolver;
exports.resolveDID = exports.simpleResolver;
